import { LatLng } from 'leaflet';
import AbstractMarkerDecoractor from '@/marker/AbstractMarkerDecoractor';
import MarkerContract from '@/marker/MarkerContract';

export default class ScaledMarker extends AbstractMarkerDecoractor {
    private scale: number;

    constructor(origin: MarkerContract, scale: number) {
        super(origin);

        this.scale = scale;
    }

    latLng(): LatLng {
        return new LatLng(
            this.origin.latLng().lat * this.scale,
            this.origin.latLng().lng * this.scale,
        );
    }
}
